import React,{ useState, useEffect} from 'react'
import dummyBannerSrc from './dummy_banner.jpg'
import suspenseBannerSrc from './suspense_banner.jpg'
import { Box, Button, Image, Text } from '../../designSystem'
import { get } from  '../../lib/api'
import Clock from '../../components/Images/Clock'
import { 
    contestContainerHeading,
    contestList,
    contestListItem,
    contestDuration,
    contestStatus,
    contestThumbnailContainer,
    contestThumbnailImage,
    allContestHeader,
    backButton,
    contestDetails,
    contestHeading,
    ContestTitle,
    StatusCircle
 } from './style'
 import ArrowLeft from '../../components/Images/ArrowLeft'
import Contest from '../../components/Images/Contest'
import { handleEventLog, checkOverseasUser } from '../../lib/utils'
import Loader from '../../components/Loader'


export const daysDifference = timeDifference => Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

const _contests = [
    {
      id: "99331462a77abe479f81b4f345c3b76cd693e8fa",
      title: 'Suspense Diaries',
      contestVisibility: 'india',
      start_date: new Date(2021, 11, 31),
      duration:daysDifference(new Date(2021,11,31) - new Date()),
      hasContestStarted: (new Date() - new Date(2021,11,31) >= 0),
      thumbnailSrc: suspenseBannerSrc,
      link: '/writer-suspense-diaries-contest.html',
    },
    {
      id: "f7b3efb413092fcb4b56ceab7324628f88aca614",
      title: 'Premayaatra - Mohabbat Bharee Kahaaniyon Ka Silasila',
      contestVisibility: 'india',
      start_date: new Date(2021, 11, 31),
      duration: daysDifference(new Date(2021,7,22) - new Date()),
      hasContestStarted: (new Date() - new Date(2021,11,31) >= 0),
      thumbnailSrc: dummyBannerSrc,
      link: '/writer-contest.html',
    } ,
    {
      id: "f81df6ce7fb2a6d3df977109b66bf3af0cca9e7c",
      title: 'Romance and Paranormal Romance',
      contestVisibility: 'row',
      start_date: new Date(2022, 4, 16),
      duration: daysDifference(new Date(2022,7,22) -  new Date()),
      hasContestStarted: (new Date() - new Date(2022,4,16) >= 0),
      thumbnailSrc: 'https://djhonz7dexnot.cloudfront.net/743b1d22e332233d0d39ca3d1111cf8f941ee0c5.jpg',
      link: '/contest/romance-and-paranormal-romance',
    } ,
    {
      id: "bcef3697e35ae3cadde6c40791828cc49fa6c74d",
      title: 'Rahasyamay Prem',
      contestVisibility: 'india',
      start_date: new Date(2022, 5, 2),
      duration: daysDifference(new Date(2022, 6, 18) -  new Date()),
      hasContestStarted: (new Date() - new Date(2022, 5, 2) >= 0),
      thumbnailSrc: 'https://djhonz7dexnot.cloudfront.net/6a1c77a47b261a26214de8f04fb7aecc6c738eda.jpg',
      link: '/contest/rahasyamay-prem',
    } ,
    {
      id: "2f524f3f930d04f9d7439070ed749819bf40bcb9",
      title: 'Science Fiction लेखन',
      contestVisibility: 'india',
      start_date: new Date(2022, 6, 5),
      duration: daysDifference(new Date(2022, 7, 21) - new Date()),
      hasContestStarted: (new Date() - new Date(2022, 6, 5) >= 0),
      thumbnailSrc: 'https://djhonz7dexnot.cloudfront.net/d3ce2836be63c43d794fbeb70cd0e3f985fcf7bc.jpg',
      link: '/contest/sci-fiction',
    } ,
]

const compare = (contestA, contestB) => {
  if (new Date(contestA.starttime) > new Date(contestB.starttime)){
      return 
  }else if (new Date(contestA.starttime) > new Date(contestB.starttime)){
      return 1
  }
  return (new Date(contestA.starttime) - new Date(contestB.starttime))
}
_contests.sort(function(a,b){
  return new Date(b.starttime) - new Date(a.starttime);
})


const Contests = ({ bookList, setIsShowAllContest, isShowAllContest, history, user, authorVisibility, authorLanguage, ...props }) => {
    const isMobile = window.screen.width < 600
    const [contests,setContests] = useState(_contests)
    const [loading, setLoading] = useState(false)
    
    useEffect(() => {
        if(!user) return 
        if((!checkOverseasUser(user) || user?.location === 'US')){
          setLoading(true)
          get('/content_api/contests/', {
            params : {
              // language: authorLanguage,
              is_novel: 1,
              locale: user?.location === 'US' ? 'US': 'IN'
            }
          }).then((contests) => {
            const newContests=contests.map(contest=>(
              {
              ...contest,
              isLive:  new Date() > new Date(contest?.starttime) && new Date() < new Date(contest?.endtime) ,
              status:findContestStatus(bookList,contest.contest_id),
            }))
            setContests(newContests)
            setLoading(false)
          })
        }else{
          const newContests=contests.map(contest=>({
            status:findContestStatus(bookList,contest.id),
          }))
          .filter(contest => contest.contestVisibility == authorVisibility && contest.hasContestStarted )
          setContests(newContests)
          setLoading(false)
        }
    },[user])

    const nagivateToContestHander = (contest) => {
      history.push(`/contest/${contest.contest_title}-${contest.contest_id}`)
    }

    const findContestStatus= (bookList,contestId) => {
        let bookPublished=false;
        if(bookList.length === 0) return "Not Registered"; 
        const bookListRegisteredInContest=bookList.filter(book=> book?.contest_data?.contest_id === contestId)
        if(bookListRegisteredInContest.length === 0) return "Not Registered";
        for(let i=0;i<bookListRegisteredInContest.length;i++){
            if(bookListRegisteredInContest[i].published === true){ 
            bookPublished=true;
            break;
            }
        }
        return bookPublished ? "Book Published": "Book Created";
    }

  const findPreviousContest = (id) => {
    const index = _contests.findIndex((contest) => contest.id === id)
    return index > -1 ? _contests[index] : null
  }
  const getContestStatus = (contest) => {
    if(contest?.extra_info?.stage2){
      return contest?.extra_info?.stage2?.winners ? 'Stage 2 Winners Announced' : 
              contest?.extra_info?.winners ? 'Stage 1 Winners Announced' : 'Contest Ended'
    }else if(!contest?.extra_info?.stage2 && contest?.extra_info?.winners){
      return 'Winners Announced'
    }
    return 'Contest Ended'
  }

  const handleSeeAll = () => {
    history.push('/home?view=all-contests')
    handleEventLog('home', 'button_click', {
      module_name: 'See All'
    })
  }

  const handleContestClick = (contest) => { 
    if (window.location.search.includes('view=all-contests')) {
      handleEventLog('allcontest', 'button_click', {
        module_name: 'contestlisting',
        entity_id: contest.contest_id,
        entity_type: 'contest' 
      })
    }
    else {
      handleEventLog('home', 'button_click', {
        module_name: 'contestlisting',
        entity_id: contest.contest_id,
        entity_type: 'contest' 
      })
    }
    nagivateToContestHander(contest)
  }

  return (
    <>
        <Box maxWidth="100vw" p={[8,0]}>
          {contests.length !==0 && 
            <Box {...contestContainerHeading}>
              {!isMobile && isShowAllContest && <Button {...backButton} variant='' onClick={() => history.goBack()}><ArrowLeft/></Button>}
              <Box display="flex" py='16px'>
                <Contest />
                <Text {...contestHeading}>Contests</Text>
              </Box>
              {!isShowAllContest && <Button variant='outlinePrimary' onClick={handleSeeAll}>See All</Button>}
            </Box>}
            <Box {...contestList}>
              {loading && <Loader />}
              {!loading && contests.length > 0 && contests.map((contest,index)=>{
              return (new Date() > new Date(contest.starttime)) && (
                <Box 
                  {...contestListItem} 
                  key={contest.contest_id} 
                  onClick={() => handleContestClick(contest)}
                >
                  <Box display="flex" flexDirection="column" width="60%" overflow="hidden">
                    {(contest.isLive) && <Text color='#54b585' fontWeight={'600'} fontSize={'1rem'} letterSpacing={'2px'}>LIVE</Text>}
                    <ContestTitle>{contest.contest_title}</ContestTitle>
                    <Box {...contestDetails}>
                      <Box pt={8}>
                        <Box {...contestDuration}>
                          {contest.isLive > 0 && <span><Clock /></span>}
                          <span>{contest.isLive > 0 ? `${Math.ceil((new Date(contest?.endtime).getTime() - new Date().getTime())/(1000 * 3600 * 24))} days left` :  getContestStatus(contest)}</span>
                        </Box>
                      </Box>
                      <Box {...contestStatus}>
                        <StatusCircle status={contest.status}/>
                        <span>{contest.status}</span>
                      </Box>
                    </Box>
                  </Box>
                  <Box {...contestThumbnailContainer}>
                    <Image {...contestThumbnailImage} src={ contest?.extra_info?.contest_intro?.thumbnail_image || findPreviousContest(contest.id || contest.contest_id)?.thumbnailSrc || ''}/>
                  </Box>
                </Box>);
              })}
            </Box>
        </Box>
    </>
  )
}
export default Contests
